import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import Permiso from "../../router/Permiso";
import { AsistenciaService } from "../../services/AsistenciaService";
import Preloader from "../../components/Preloader";

const ListadoMarcacion = ({ token, refreshTrigger = 0 }) => {
    const [asistencias, setAsistencias] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [buscarDocumento, setBuscarDocumento] = useState("");
    const [buscarNombre, setBuscarNombre] = useState("");
    const [totalRegistros, setTotalRegistros] = useState(0);

    const fetchListadoMarcacion = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const { asistencias, totalPaginas, totalRegistros } = await AsistenciaService.getAsistenciaMarcacion({
                token,
                pagina: currentPage,
                pageSize: 20,
                desde: fechaInicio,
                hasta: fechaFin,
                documento: buscarDocumento,
                nombre: buscarNombre,
            });

            setAsistencias(asistencias);
            setTotalPages(totalPaginas);
            setTotalRegistros(totalRegistros);
        } catch (err) {
            setError("Error al cargar las asistencia");
            console.error("Error:", err);
        } finally {
            setLoading(false);
        }
    }, [token, currentPage, fechaInicio, fechaFin, buscarDocumento, buscarNombre]);

    useEffect(() => {
        fetchListadoMarcacion();
    }, [currentPage, fechaInicio, fechaFin, refreshTrigger, buscarDocumento, buscarNombre, fetchListadoMarcacion]);

    const exportarExcel = async () => {
        try {
            setLoading(true);
            const filtros = {
                desde: fechaInicio,
                hasta: fechaFin,
                documento: buscarDocumento,
                nombre: buscarNombre,
            };

            const blob = await AsistenciaService.exportarMarcacionExcel(token, filtros);

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "listado_asistencia_marcación.xlsx";
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error al exportar Excel:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <Preloader />;

    return (
        <div className="ventas-admin-container">
            <div className="ventas-table-header">
                <h2 className="ventas-table-title">Listado de Marcación  </h2>
                <div className="productos-actions">
                    <Permiso permiso="exportar_asistencia">
                        <button onClick={exportarExcel} className="btn-exportar">
                            Exportar a Excel
                        </button>
                    </Permiso>
                </div>
            </div>

            {/* Filtros */}
            <div className="usuarios-filtros">
                <div className="filtro-item">
                    <label htmlFor="fecha-inicio">Fecha Inicio:</label>
                    <input
                        type="date"
                        value={fechaInicio}
                        onChange={(e) => setFechaInicio(e.target.value)}
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="fecha-fin">Fecha Fin:</label>
                    <input
                        type="date"
                        value={fechaFin}
                        onChange={(e) => setFechaFin(e.target.value)}
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="numero-documento">Número del Documento:</label>
                    <input
                        type="text"
                        value={buscarDocumento}
                        onChange={(e) => setBuscarDocumento(e.target.value)}
                        placeholder="Ingrese número "
                    />
                </div>
                <div className="filtro-item">
                    <label htmlFor="buscar-por">Buscar por :</label>
                    <input
                        type="text"
                        value={buscarNombre}
                        onChange={(e) => setBuscarNombre(e.target.value)}
                        placeholder="Nombre, apellido o nombre completo"
                    />
                </div>
                <div className="filtro-item">
                    <button
                        onClick={() => {
                            setFechaInicio("");
                            setFechaFin("");
                            setBuscarDocumento("");
                            setBuscarNombre("");
                            setCurrentPage(1);
                            fetchListadoMarcacion();
                        }}
                        className="btn-limpiar"
                    >
                        Limpiar Filtros
                    </button>
                </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            {loading ? (
                <div className="loading">Cargando asistencia...</div>
            ) : (
                <>
                    <div className="ventas-table-wrapper">
                        <table className="ventas-table">
                            <thead>
                                <tr>
                                    <th>Tipo de Documento</th>
                                    <th>Número</th>
                                    <th>Nombres y Apellidos</th>
                                    <th>Supervisor</th>
                                    <th>Fecha</th>
                                    <th>Hora Ingreso</th>
                                    <th>Hora Salida</th>
                                    <th>Inicio Ref.</th>
                                    <th>Fin Ref.</th>
                                    <th>Min. Tarde</th>
                                    <th>Minutos R.</th>
                                    <th>E. Asistencia</th>
                                    <th>Limites</th>
                                </tr>
                            </thead>
                            <tbody>
                                {asistencias.map((asistencia) => {
                                    return (
                                        <tr key={`${asistencia.id}-${asistencia.fecha_asistencia || ''}`}>
                                            <td>{asistencia.tipo_documento}</td>

                                            <td>{asistencia.numero_documento}</td>
                                            <td>{asistencia.nombres} {asistencia.apellidoPaterno} {asistencia.apellidoMaterno}</td>
                                            <td>{asistencia.nombre_supervisor} {asistencia.apellido_supervisor}</td>
                                            <td>
                                                {new Date(asistencia.fecha_asistencia).toLocaleDateString()}
                                            </td>

                                            <td>{asistencia.hora_ingreso_asistencia}</td>
                                            <td>{asistencia.hora_salida_asistencia}</td>
                                            <td>{asistencia.HoraRefrigerioInicio}</td>
                                            <td>{asistencia.HoraRefrigerioFin}</td>
                                            <td>{asistencia.minutosTarde}</td>
                                            <td>{asistencia.MinutosRefrigerio}</td>
                                            <td className="ventas-acciones">{asistencia.estado_asistencia}</td>
                                            <td style={{ color: asistencia.dentro_de_limites ? 'inherit' : 'red', fontWeight: asistencia.dentro_de_limites ? 'normal' : 'bold' }}>
                                                {asistencia.dentro_de_limites ? 'SI' : 'NO'}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
                        {" "}
                        Total de registros: {totalRegistros}{" "}
                    </span>
                    {/* Paginación */}
                    <div className="pagination">
                        <button
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            Anterior
                        </button>
                        <span>
                            Página {currentPage} de {totalPages}
                        </span>
                        <button
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            Siguiente
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

ListadoMarcacion.propTypes = {
    token: PropTypes.string.isRequired,
    refreshTrigger: PropTypes.number,
};

export default ListadoMarcacion;
